// Map of MIME types to user-friendly labels
const MIME_TYPE_MAP: Record<string, string> = {
  // CSV - handle both standard and non-standard
  'text/csv': 'csv',
  'application/csv': 'csv',

  // Excel formats
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12': 'xlsb',

  // JSON
  'application/json': 'json',
  'text/json': 'json',

  // Parquet
  'application/vnd.apache.parquet': 'parquet',

  // Text
  'text/plain': 'txt',
  'text/rtf': 'rtf',
  'text/markdown': 'md',

  // PDF
  'application/pdf': 'pdf',

  // Word formats
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',

  // PowerPoint formats
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',

  // Code files
  'text/javascript': 'js',
  'application/javascript': 'js',
  'text/typescript': 'ts',
  'text/x-python': 'py',
  'text/x-shellscript': 'sh',
  'text/x-r': 'r',
  'text/x-sql': 'sql',

  // XML
  'application/xml': 'xml',
  'text/xml': 'xml',

  // Images
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',

  // Video
  'video/mp4': 'mp4',
  'video/webm': 'webm',
  'video/quicktime': 'mov',

  // Audio
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'audio/ogg': 'ogg',
};

/**
 * Maps content MIME types to user-friendly file type labels
 * Handles both standard and non-standard MIME types
 */
export const getFileTypeLabel = (
  contentType: string | null | undefined,
): string => {
  if (!contentType) return '';

  // Normalize content type (remove charset, etc.)
  const mimeType = contentType.split(';')[0].trim().toLowerCase();

  // Check if we have a direct mapping
  if (MIME_TYPE_MAP[mimeType]) {
    return MIME_TYPE_MAP[mimeType];
  }

  // Try to extract extension from MIME type as fallback
  // e.g., "application/zip" -> "zip"
  const parts = mimeType.split('/');
  if (parts.length === 2) {
    const subtype = parts[1];
    // Handle complex subtypes like "vnd.something"
    const lastPart = subtype.split('.').pop() || subtype;
    return lastPart.toLowerCase();
  }

  return '';
};
